import AppLayout from '@/components/AppLayout.tsx'
import PageTitle from '@/components/PageTitle'
import PlanSwitcher, { type PlanSwitcherData } from './components/PlanSwitcher'

interface Props {
  plan_switcher: PlanSwitcherData
}

// Only rendered when no plan is selectable: the server sends published session
// plans straight to the VersionView recap and draft-only picks to the editor.
// Plans are created by the planning cycle (Plan::TopDownPlanningTasks, driven
// by Task Settings) — there is no manual create flow anymore.
export default function Index({ plan_switcher }: Props) {
  const hasPlans = plan_switcher.plans.length > 0
  return (
    <AppLayout header={<PageTitle title="Top Down Plans" subtitle="Pick a plan to work with" />}>
      <div className="mb-3"><PlanSwitcher data={plan_switcher} /></div>
      <div style={{ textAlign: 'center', padding: '80px 20px', color: 'var(--muted-foreground)', border: '1px solid var(--border)', borderRadius: 8, background: 'white' }}>
        <div style={{ fontSize: 40, color: 'var(--border)', marginBottom: 12 }}>◎</div>
        {hasPlans ? (
          <>
            <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--foreground)', marginBottom: 6 }}>No plan selected</div>
            <div style={{ fontSize: 12, color: 'var(--muted-foreground)', marginBottom: 20 }}>
              Use the plan switcher above to pick the plan you want to work with
            </div>
          </>
        ) : (
          <>
            <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--foreground)', marginBottom: 6 }}>No plans yet</div>
            <div style={{ fontSize: 12, color: 'var(--muted-foreground)' }}>
              Plans are created automatically by the planning cycle — set up people and a start date in Task Settings
            </div>
          </>
        )}
      </div>
    </AppLayout>
  )
}
